export default __webpack_public_path__ + "static/media/icon-dashboard.8e56ced7.png";